import { Component } from '@angular/core';
import {TrackingHelperService} from "./services/tracking-helper.service";
import {LanguageService} from "./services/language.service";
import {Meta} from "@angular/platform-browser";
import {ConfigService} from "./services/config.service";
// import {ModalService} from "./services/modal.service";



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent {

  brandName:string;

  constructor(
    private configs: ConfigService,
    private metaService: Meta,
    private trackingService: TrackingHelperService,
    private langService: LanguageService,
    // private modalService: ModalService
  ) {
    this.brandName = this.configs.brandName;

    this.metaService.addTags([
      {name: 'description', content: this.configs.metaDesc},
      {name: 'author', content: this.brandName},
      {name: 'keywords', content: 'online casino, slots, blackjack, live dealer game, table game, gambling bonuses, poker, free spins, real money, cash rewards, big jackpot, deposit bonus, secure transaction, fast payout, bitcoin payment'}
    ])
    this.langService.initializeLanguage();

    //tracking and analytics
    this.trackingService.setCookiesFromQueryParams();
  }


  ngAfterViewInit() {
    // this.modalService.openModal$.subscribe((modalId: string|null) => {
    //   console.log(modalId);
    //   //todo we dont need this - remove when done with opening modals on landings
    //
    // });



  }

}
